import { isKnownProfileInput } from "../profiles/index.js";
import { ModelResolutionError } from "../errors.js";
import type { ModelResolutionNotFound } from "../sync/modelNameResolver/types.js";
import type { InvokeModelResolutionInput } from "./types.js";

export const MODEL_PROFILE_UNROUTABLE = "MODEL_PROFILE_UNROUTABLE";

export class ModelProfileUnroutableError extends Error {
  readonly code = MODEL_PROFILE_UNROUTABLE;

  constructor(
    readonly profileKey: string,
    readonly provider: string | undefined,
    cause?: unknown,
  ) {
    super(
      `Profile choice "${profileKey}" could not be routed to a concrete model` +
        (provider ? ` (provider hint: ${provider})` : ""),
    );
    this.name = "ModelProfileUnroutableError";
    if (cause !== undefined) {
      this.cause = cause;
    }
  }
}

export function enrichModelResolutionError(
  input: InvokeModelResolutionInput,
  resolution: ModelResolutionNotFound,
): ModelResolutionError | ModelProfileUnroutableError {
  const base = new ModelResolutionError(input, resolution);
  if (isKnownProfileInput(input.model)) {
    return new ModelProfileUnroutableError(input.model, input.provider, base);
  }
  return base;
}
